import { fetchGet, fetchPost } from '~utilities/fetch';
import ListSortOrderEnum from './ListSortOrderEnum';

export async function investmentSaleTransferGetRequest(investmentSaleTransferUuid: string): Promise<Response> {
    return fetchGet(`/investment-sale-transfers/${investmentSaleTransferUuid}`);
}

export async function investmentSaleTransferSendRequest(investmentSaleTransferUuid: string): Promise<Response> {
    return fetchPost(`/investment-sale-transfers/${investmentSaleTransferUuid}/send`);
}

export async function investmentSaleTransfersAddRequest(investmentUuid: string, investorAccountInvestmentTransactionsUuids: string[]): Promise<Response> {
    return fetchPost(`/investments/${investmentUuid}/investment-sale-transfers`, {
        investorAccountInvestmentTransactionsUuids,
    });
}

export async function investmentSaleTransfersUnallocatedInvestmentsListRequest(): Promise<Response> {
    return fetchGet('/investment-sale-transfers/unallocated-investments');
}

export async function investmentSaleTransferHistoriesListRequest(investmentSaleTransferUuid: string): Promise<Response> {
    return fetchGet(`/investment-sale-transfers/${investmentSaleTransferUuid}/history`);
}

export async function investmentSaleTransferInvestorAccountInvestmentTransactionsListRequest(investmentSaleTransferUuid: string): Promise<Response> {
    return fetchGet(`/investment-sale-transfers/${investmentSaleTransferUuid}/investor-investment-transactions`);
}

export async function investmentSaleTransfersPaginatedListRequest(
    page: number,
    perPage: number,
    orderBy: string,
    order: ListSortOrderEnum,
): Promise<Response> {
    return fetchGet('/investment-sale-transfers', {
        order,
        orderBy,
        page,
        perPage,
    });
}